export default "__VITE_ASSET__CSX7nkIb__"